import { render, staticRenderFns } from "./details.vue?vue&type=template&id=1ce3c110&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=1ce3c110&prod&lang=less&scoped=true&"
import style1 from "./details.vue?vue&type=style&index=1&id=1ce3c110&prod&lang=less&scoped=true&"
import style2 from "./details.vue?vue&type=style&index=2&id=1ce3c110&prod&lang=less&scoped=true&"
import style3 from "./details.vue?vue&type=style&index=3&id=1ce3c110&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce3c110",
  null
  
)

export default component.exports